"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  QWERTY: {
    REGULAR: [['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'backspace'], ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'], ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'], ['Z', 'X', 'C', 'V', 'B', 'N', 'M']],
    EMAIL: [['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'backspace'], ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'], ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', '@'], ['z', 'x', 'c', 'v', 'b', 'n', 'm', '.', '_', '-']],
    NUMBER: [['7', '8', '9'], ['4', '5', '6'], ['1', '2', '3'], ['0', 'backspace']]
  },
  QWERTZ: {
    REGULAR: [['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'backspace'], ['Q', 'W', 'E', 'R', 'T', 'Z', 'U', 'I', 'O', 'P'], ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'], ['Y', 'X', 'C', 'V', 'B', 'N', 'M']],
    EMAIL: [['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'backspace'], ['q', 'w', 'e', 'r', 't', 'z', 'u', 'i', 'o', 'p'], ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', '@'], ['y', 'x', 'c', 'v', 'b', 'n', 'm', '.', '_', '-']],
    NUMBER: [['7', '8', '9'], ['4', '5', '6'], ['1', '2', '3'], ['0', 'backspace']]
  },
  AZERTY: {
    REGULAR: [['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'backspace'], ['A', 'Z', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'], ['Q', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'M'], ['W', 'X', 'C', 'V', 'B', 'N']],
    EMAIL: [['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'backspace'], ['a', 'z', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'], ['q', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'm', '@'], ['w', 'x', 'c', 'v', 'b', 'n', '.', '_', '-']],
    NUMBER: [['7', '8', '9'], ['4', '5', '6'], ['1', '2', '3'], ['0', 'backspace']]
  }
};
exports.default = _default;